import React from 'react';
import AbstractIcon from './AbstractIcon';
var Icon = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentcolor",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M17.983 11.7316L17.9996 10.0798C17.9999 10.0533 18 10.0267 18 10C18 6.68629 15.3137 4 12 4C8.68629 4 6 6.68629 6 10C6 10.0267 6.00013 10.0533 6.0004 10.0798L6.01706 11.7315L4.39816 12.06C3.02951 12.3377 2 13.5508 2 15C2 16.6569 3.34315 18 5 18H19C20.6569 18 22 16.6569 22 15C22 13.5508 20.9705 12.3377 19.6018 12.06L17.983 11.7316ZM20 10C20 10.0334 19.9998 10.0667 19.9995 10.0999C22.282 10.563 24 12.5809 24 15C24 17.7614 21.7614 20 19 20H5C2.23858 20 0 17.7614 0 15C0 12.5809 1.71801 10.563 4.0005 10.0999C4.00017 10.0667 4 10.0334 4 10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10Z"
  }));
});
var DescriptiveCloud = AbstractIcon.withComponent(Icon);
DescriptiveCloud.displayName = 'DescriptiveCloud';
export default DescriptiveCloud;